<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import type { CtaBlock } from 'query-strapi-v4';
  import { onMount } from 'svelte';
  import { Button } from '$lib/components/ui/button';
  import WithImage from './WithImage.svelte';
  type Link = {
    href: string;
    target: '_blank' | '_self';
    text: string;
  };
  type Block = $$Generic<CtaBlock | undefined>;
  export let block = undefined as CtaBlock;
  export let blocksLength: number = 0;
  export let blockIndex: number = 0;

  const dispatch = createEventDispatcher<{
    'analytics-event': {
      name: 'Cta';
      props: {
        Title: string;
        Text: string;
        Href: string;
      };
    };
  }>();

  const defaultTitle = 'Ban Porn from your technology';
  const defaultDescription = 'Access blocking techniques that actually work';
  // If no link is set, use the standard one
  const placeholderLink: Link = {
    href: '/',
    target: '_self',
    text: 'Learn More'
  };

  const title = block.title ?? defaultTitle;
  const description = block.description ?? defaultDescription;

  let params = new URLSearchParams();
  let trackingInfo = {
    utm_medium: 'in-content-cta',
    utm_term: block.title || defaultTitle,
    utm_content: block.description || defaultDescription
  };
  for (let key in trackingInfo) {
    params.append(key, trackingInfo[key]);
  }
  $: queryString = params.toString();

  onMount(() => {
    params.append('utm_source', document.referrer);
    params = params;
  });

  $: href = block?.link?.href || placeholderLink.href + '?' + queryString;

  const handleButtonClick = () => {
    dispatch('analytics-event', {
      name: 'Cta',
      props: {
        Title: `${title} - index - ${blockIndex} - count - ${blocksLength}`,
        Text: description,
        Href: href
      }
    });
    if (window !== undefined) {
      window.location = href;
    }
  };
</script>

{#if block?.featured_image?.data?.attributes?.url}
  <WithImage
    image={block.featured_image}
    {title}
    {description}
    link={block.link}
    onClick={handleButtonClick}
  />
{:else}
  <div class="not-prose bg-gray-1100 text-white text-center rounded-lg my-8 bg-[url('/grid.svg')]">
    <div class="p-6">
      <div class="text-xl font-semibold mb-2 tracking-tight">
        <h3>
          {title}
        </h3>
      </div>
      <div class="text-base font-thin tracking-tight">
        <p>{description}</p>
      </div>
      <div class="mt-4">
        {#if block.link && block.link.href}
          <Button on:click={handleButtonClick} target={block.link.target}>{block.link.text}</Button>
        {:else}
          <Button on:click={handleButtonClick} target={placeholderLink.target}>
            {placeholderLink.text}
          </Button>
        {/if}
      </div>
    </div>
  </div>
{/if}
